import { Skeleton, Stack } from '@omnipresentgroup/design-system';

export const BankDetailsSkeleton = () => {
  return (
    <Stack gap="16">
      <Stack gap="8">
        <Skeleton height={32} width={200} />
        <Skeleton height={14} />
      </Stack>
      <Stack gap="4">
        <Skeleton height={14} width={200} />
        <Skeleton height={40} />
      </Stack>
      <Stack gap="4">
        <Skeleton height={14} width={200} />
        <Skeleton height={40} />
      </Stack>
      <Stack gap="4">
        <Skeleton height={14} width={200} />
        <Skeleton height={40} />
      </Stack>
      <Stack gap="4">
        <Skeleton height={14} width={200} />
        <Skeleton height={40} />
      </Stack>
    </Stack>
  );
};
